import { useIntl } from "react-intl";
import { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

//Components
import { Checkbox, Button, TableView, Toolbar, ToggleSwitch } from "@gpstrackit/react-controls";
import { Grid, Collapse } from "@mui/material";

//Notification
import { HasPermission } from 'Core/security';
//Actions
import { packagesFeaturesSetRoleModules } from 'Redux/actions';

const TablePM = (props) => {
    const {
        id,
        indent = 0,
        template,
        loading,
        setChanges,
        applyChanges,
        changes,
        height,
    } = props;

    const { messages } = useIntl();
    const dispatch = useDispatch();
    const user = useSelector(state => state.securityRedux.user);

    const [expanded, setExpanded] = useState([]);
    const [currentSearch, setCurrentSearch] = useState("");
    const [expandAll, setExpandedAll] = useState(false);

    const expand = useCallback((nodeId) => {
        let newExpanded = [...expanded];
        if (expanded.includes(nodeId)) {
            newExpanded = expanded.filter(e => e != nodeId);
        } else newExpanded.push(nodeId);

        setExpanded(newExpanded);
    });

    const deleteItems = (array) => {
        return [...new Set(array)];
    }


    const handleExpandAll = (value) => {
        setExpandedAll(value)
        if (value) {
            let parents = template?.filter((item) => item?.parentModuleId).map((item) => item?.parentModuleId)
            let newParents = deleteItems(parents)
            setExpanded(newParents)
        } else {
            setExpanded([])
        }
    }

    const renderHeader = useCallback((treeView = true) => {
        return (
            <Grid container className="feature-tab-header">
                <Grid item xs={3}>
                    <span className="feature-tab-header-label" style={{ paddingLeft: treeView ? 25 : 8 }}>{messages['packages_features_feature_name']}</span>
                </Grid>
                <Grid item xs>
                    <span className="feature-tab-header-label">{messages['packages_features_code']}</span>
                </Grid>
                <Grid item xs={3}>
                    <span className="feature-tab-header-label">{messages['packages_features_description']}</span>
                </Grid>
                <Grid item xs>
                    <span className="feature-tab-header-label">{messages['packages_features_read']}</span>
                </Grid>
                <Grid item xs>
                    <span className="feature-tab-header-label">{messages['packages_features_create']}</span>
                </Grid>
                <Grid item xs>
                    <span className="feature-tab-header-label">{messages['packages_features_update']}</span>
                </Grid>
                <Grid item xs>
                    <span className="feature-tab-header-label">{messages['packages_features_delete']}</span>
                </Grid>
            </Grid>
        );
    });

    let codes = ["man", "devmod", "rol", "usr", "cact", "chact", "coact"]

    return (
        <TableView
            name={`tags-list-level-${id}`}
            onSearch={(search) => setCurrentSearch(search)}
            data={currentSearch ? template : id ? template?.filter((item) => item?.parentModuleId === id) : template?.filter((item) => !item?.parentModuleId) || []}
            loading={!id && loading}
            rowsPerPage={100}
            viewType="list"
            messages={messages}
            topSpaceSize={370}
            height={id ? "100%" : null}
            containerHeight={id ? null : height}
            itemSelector={false}
            renderHeader={id ? null : renderHeader}
            renderRow={(feature) => {
                let validateModule = template?.some((item) => item?.parentModuleId === feature?.id)

                let createValidacion = feature?.availablePermissions ? feature?.availablePermissions.includes("c") : false
                let updateValidacion = feature?.availablePermissions ? feature?.availablePermissions.includes("u") : false
                let deleteValidacionT = feature?.availablePermissions ? feature?.availablePermissions.includes("d") : false

                return (
                    <div style={{ minWidth: 650 }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            className="row-features"
                        >
                            <Grid item xs={3}>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    style={{ marginLeft: indent }}
                                    wrap="nowrap"
                                >
                                    <Grid item>
                                        {
                                            (!id && validateModule && !currentSearch) || (codes.includes(feature.code) && !currentSearch) ?
                                                <Button
                                                    type="icon"
                                                    icon={expanded.includes(feature.id) ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}
                                                    placement="bottom"
                                                    className="btn-xs"
                                                    fontSize="inherit"
                                                    onClick={(e) => expand(feature.id)}
                                                /> :
                                                <div style={{ width: 24, height: 24 }}></div>
                                        }
                                    </Grid>
                                    <Grid item xs>
                                        <Grid
                                            container
                                            alignItems="center"
                                            justifyContent="flex-start"
                                            className="context-menu-container"
                                            wrap="nowrap"
                                        >
                                            <Grid item zeroMinWidth style={{ marginRight: 5 }}>
                                                {feature.name}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs>
                                <span>{feature.code}</span>
                            </Grid>
                            <Grid item xs={3}>
                                <div style={{ marginRight: 5, whiteSpace: 'normal' }}>
                                    <span>{feature.description || feature.name}</span>
                                </div>
                            </Grid>
                            <Grid item xs>
                                <span className="container-checkbox" style={{ fontWeight: 'bold' }}>
                                    <Checkbox
                                        id={`update-read-feature-${feature?.id}`}
                                        value={feature?.r}
                                        onChange={(checked) => {
                                            if (!loading) {
                                                let currentRoleModules = JSON.parse(JSON.stringify(template));
                                                let indexItem = currentRoleModules.findIndex((value) => value.id === feature.id);

                                                if (indexItem > -1) currentRoleModules[indexItem].r = checked
                                                if (!checked) {
                                                    if (createValidacion) currentRoleModules[indexItem].c = false
                                                    if (updateValidacion) currentRoleModules[indexItem].u = false
                                                    if (deleteValidacionT) currentRoleModules[indexItem].d = false
                                                }

                                                setChanges(true);
                                                dispatch(packagesFeaturesSetRoleModules([...currentRoleModules]));
                                            }
                                        }}
                                    />
                                </span>
                            </Grid>
                            <Grid item xs>
                                <span className="container-checkbox" style={{ fontWeight: 'bold' }}>
                                    <Checkbox
                                        id={`update-create-feature-${feature?.id}`}
                                        value={createValidacion ? feature?.c : false}
                                        onChange={(checked) => {
                                            if (!loading) {
                                                let currentRoleModules = JSON.parse(JSON.stringify(template));
                                                let indexItem = currentRoleModules.findIndex((value) => value.id === feature.id);

                                                if (indexItem > -1) currentRoleModules[indexItem].c = checked

                                                if (!checked && !feature?.u && !feature?.d) currentRoleModules[indexItem].r = false

                                                if (checked && !feature?.r) currentRoleModules[indexItem].r = checked

                                                setChanges(true);
                                                dispatch(packagesFeaturesSetRoleModules([...currentRoleModules]));
                                            }
                                        }}
                                        disabled={!createValidacion}
                                    />
                                </span>
                            </Grid>
                            <Grid item xs>
                                <span className="container-checkbox" style={{ fontWeight: 'bold' }}>
                                    <Checkbox
                                        id={`update-feature-${feature?.id}`}
                                        value={updateValidacion ? feature?.u : false}
                                        onChange={(checked) => {
                                            if (!loading) {
                                                let currentRoleModules = JSON.parse(JSON.stringify(template));
                                                setChanges(true);
                                                let indexItem = currentRoleModules.findIndex((value) => value.id === feature.id);

                                                if (indexItem > -1) currentRoleModules[indexItem].u = checked

                                                if (!checked && !feature?.c && !feature?.d) currentRoleModules[indexItem].r = false

                                                if (checked && !feature?.r) currentRoleModules[indexItem].r = checked

                                                dispatch(packagesFeaturesSetRoleModules([...currentRoleModules]));
                                            }
                                        }}
                                        disabled={!updateValidacion}
                                    />
                                </span>
                            </Grid>
                            <Grid item xs>
                                <span className="container-checkbox" style={{ fontWeight: 'bold' }}>
                                    <Checkbox
                                        id={`update-delete-${feature?.id}`}
                                        value={deleteValidacionT ? feature?.d : false}
                                        onChange={(checked) => {
                                            if (!loading) {
                                                let currentRoleModules = JSON.parse(JSON.stringify(template));
                                                setChanges(true);
                                                let indexItem = currentRoleModules.findIndex((value) => value.id === feature.id);

                                                if (indexItem > -1) currentRoleModules[indexItem].d = checked

                                                if (!checked && !feature?.c && !feature?.u) currentRoleModules[indexItem].r = false

                                                if (checked && !feature?.r) currentRoleModules[indexItem].r = checked

                                                dispatch(packagesFeaturesSetRoleModules([...currentRoleModules]));
                                            }
                                        }}
                                        disabled={!deleteValidacionT}
                                    />
                                </span>
                            </Grid>
                        </Grid>
                        {
                            !currentSearch &&
                            <Collapse in={expanded.includes(feature.id)} timeout="auto" unmountOnExit>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                    style={{ padding: '0px 0px 0px 0px' }}
                                >
                                    <TablePM id={feature.id} indent={indent + 10} loading={loading} template={template} setChanges={setChanges} />
                                </Grid>
                            </Collapse>
                        }
                    </div >
                )
            }}
            pagination={false}
            inputSearch={!id ? true : false}
            toolbarContainerClassName='table-feature-toolbar-container'
            extraToolbar={id ? null : () => {
                return (
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        style={{ height: 45 }}
                    >
                        <Grid item xs={6}>
                            <ToggleSwitch
                                id="toogle-expand-all"
                                large
                                blueToggle
                                optionLabels={[messages['common_contract'], messages['common_expand']]}
                                checked={expandAll}
                                onChange={handleExpandAll}
                            />
                        </Grid>
                        <Grid item xs style={{ display: 'flex', justifyContent: 'space-around' }}>
                            <span style={{ fontWeight: 'bold' }}>{messages['packages_features_all']}</span>
                        </Grid>
                        <Grid item xs>
                            <Checkbox
                                id="update-all-read-feature"
                                value={!template?.some((item) => !item?.r)}
                                disabled={loading}
                                onChange={(checked) => {
                                    if (!loading) {
                                        let currentRoleModules = JSON.parse(JSON.stringify(template));
                                        let newRoleModules = currentRoleModules.map((item) => {
                                            let cValidacion = item?.availablePermissions ? item?.availablePermissions.includes("c") : false
                                            let uValidacion = item?.availablePermissions ? item?.availablePermissions.includes("u") : false
                                            let dValidacion = item?.availablePermissions ? item?.availablePermissions.includes("d") : false
                                            return {
                                                ...item, r: checked,
                                                c: cValidacion && !checked ? false : item?.c,
                                                u: uValidacion && !checked ? false : item?.u,
                                                d: dValidacion && !checked ? false : item?.d
                                            }
                                        });
                                        dispatch(packagesFeaturesSetRoleModules([...newRoleModules]));
                                        setChanges(true);
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs>
                            <Checkbox
                                id="update-all-create-feature"
                                value={!template?.some((item) => (item?.availablePermissions ? item?.availablePermissions.includes("c") : false) && !item?.c)}
                                disabled={loading}
                                onChange={(checked) => {
                                    if (!loading) {
                                        let currentRoleModules = JSON.parse(JSON.stringify(template));

                                        let updateValidation = currentRoleModules.some((item) => item.u)
                                        let deleteValidation = currentRoleModules.some((item) => item.d)

                                        let newRoleModules = currentRoleModules.map((item) => {
                                            let createValidacion = item?.availablePermissions ? item?.availablePermissions.includes("c") : false
                                            return {
                                                ...item,
                                                c: createValidacion ? checked : false,
                                                r: !checked ? (!updateValidation && !deleteValidation) ? false : item?.r : checked
                                            }
                                        });

                                        dispatch(packagesFeaturesSetRoleModules([...newRoleModules]));
                                        setChanges(true);
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs>
                            <Checkbox
                                id="update-all-feature"
                                disabled={loading}
                                value={!template?.some((item) => (item?.availablePermissions ? item?.availablePermissions.includes("u") : false) && !item?.u)}
                                onChange={(checked) => {
                                    if (!loading) {
                                        let currentRoleModules = JSON.parse(JSON.stringify(template));

                                        let createValidation = currentRoleModules.some((item) => item.c)
                                        let deleteValidation = currentRoleModules.some((item) => item.d)

                                        let newRoleModules = currentRoleModules.map((item) => {
                                            let updateValidacion = item?.availablePermissions ? item?.availablePermissions.includes("u") : false

                                            return {
                                                ...item,
                                                u: updateValidacion ? checked : false,
                                                r: !checked ? (!createValidation && !deleteValidation) ? false : item?.r : checked
                                            }
                                        });
                                        dispatch(packagesFeaturesSetRoleModules([...newRoleModules]));
                                        setChanges(true);
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs>
                            <Checkbox
                                id="update-all-delete"
                                disabled={loading}
                                value={!template?.some((item) => (item?.availablePermissions ? item?.availablePermissions.includes("d") : false) && !item?.d)}
                                onChange={(checked) => {
                                    if (!loading) {
                                        let currentRoleModules = JSON.parse(JSON.stringify(template));

                                        let createValidation = currentRoleModules.some((item) => item.c)
                                        let updateValidation = currentRoleModules.some((item) => item.u)

                                        let newRoleModules = currentRoleModules.map((item) => {
                                            let deleteValidacion = item?.availablePermissions ? item?.availablePermissions.includes("d") : false
                                            return {
                                                ...item,
                                                d: deleteValidacion ? checked : false,
                                                r: !checked ? (!createValidation && !updateValidation) ? false : item?.r : checked
                                            }
                                        });
                                        dispatch(packagesFeaturesSetRoleModules([...newRoleModules]));
                                        setChanges(true);
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                )
            }}
        >
            {
                !id && (
                    <Toolbar>
                        <div>
                            {
                                changes &&
                                <Button
                                    className="btn-dark-blue"
                                    onClick={() => applyChanges()}
                                    style={{ margin: -5 }}
                                    disabled={!HasPermission(user, "rolft", "u") || loading}
                                >
                                    {messages['packages_features_save_changes']}
                                </Button>
                            }
                        </div>
                    </Toolbar>
                )
            }
        </TableView>
    );
};

export default TablePM